import {useEffect, useRef, useState} from "react";

export default function RenderHTMLWithScript({ html }) {
    const containerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const container = containerRef.current;
        if(!container) return;
        const elems: HTMLScriptElement[] = []
        const scripts = container.querySelectorAll('script');
        scripts.forEach((script) => {
            const newScript = document.createElement('script');
            elems.push(newScript);
            if (script.src) {
                newScript.src = script.src;
            } else {
                newScript.textContent = script.textContent;
            }
            document.body.appendChild(newScript);
            script.remove();
        });
        return ()=>{
            elems.forEach(elem => {
                elem.remove();
            })
        }
    }, [html]);

    return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: html }} />;
}
